module.exports = __webpack_public_path__ + "static/media/Klon.c04a758c.mp3";